import catchify from 'catchify';
import { COLLECTIONS_URL, SMART_COLLECTIONS_URL } from '@/constants/api';

export const handler = async (
  usingSmartCollections, templateSlug, collectionSlug, $cachios, $store,
) => {
  if (usingSmartCollections) {
    const [smartError, smartResponse] = await catchify(
      $cachios.get(`${SMART_COLLECTIONS_URL}/${collectionSlug}/?format=json&template_slug=${templateSlug}&include[]=open_graph`),
    );

    const { data: { smart_collection: collection } = {} } = smartResponse || {};

    if (!smartError) {
      const urlParams = new URLSearchParams(collection.query_parameters);
      const fetchArgs = {};
      urlParams.forEach((value, key) => {
        fetchArgs[`profile{${key}}`] = value;
      });

      return {
        collection,
        fetchArgs,
        blocks: [],
        usingSmartCollections: true,
      };
    }
  }

  const [error, response] = await catchify(
    $cachios.get(`${COLLECTIONS_URL}/${collectionSlug}/?format=json`, {
      params: {
        staff: !!($store.state.session.user?.is_staff),
      },
    }),
  );

  if (error) {
    if (error.response && error.response.status === 404) {
      return { error: 404 };
    }

    return { error: true };
  }

  return {
    collection: response.data,
    fetchArgs: {},
    blocks: response.data.blocks,
    usingSmartCollections: false,
  };
};

export default {
  handler,
};
